import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { CompanyService } from '../data/company.service';
import { companyCommand } from '../../command/company.command';
import { Observable } from 'rxjs';

@Injectable()
export class CompanyExportCommandHandler implements ICommandHandler {
  constructor(private readonly _dataService: CompanyService, private readonly _nativeWindow: NativeWindowService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === companyCommand.export && command.itemsSource.length > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(
        map(file => {
          this._nativeWindow.save(file);
        })
      );
    }
  }
}
